import { React, useState, useEffect, createContext, useMemo } from "react";
import request from "../../../Helpers/API";
import { Autocomplete, Button, Modal, Box, TextField, MenuItem, InputAdornment } from "@mui/material";
import Swal from "sweetalert2";
import { LoaderScreen } from "../../components/LoaderScreen";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import ClienteAutocomplete from "./AutocompleteCliente";

const SubirListadoModal = ({ open, onClose, tipo }) => {
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const [evidencia, setEvidencia] = useState({
        documento: "",
        extension: "",
    })

    const AgregarCliente = () => {
        if (evidencia.documento === "" || evidencia.documento === null || evidencia.documento === undefined) {
            Swal.fire({
                title: "CLIENTES ESPECIALES",
                text: "Debe subir un documento",
                icon: "warning",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            return;
        }

        const post = {
            // idcliente: cliente.idCliente,
            // comentarios: cliente.comentario,
            // estatus: cliente.especial,
            // tipo_cliente: cliente.tipo,
            tipodoc: tipo,
            usuario: 0,
            documento: evidencia.documento,
            extension: evidencia.extension
        };

        setLoader({ ...loader, mostrar: true });
        request
            .post("ClientesEspeciales/GuardarDocumento", post)
            .then(async (result) => {
                setLoader({ ...loader, mostrar: false });
                onClose();
                await Swal.fire({
                    title: "CLIENTES ESPECIALES",
                    text: "Registro guardado con éxito",
                    icon: "success",
                    customClass: {
                        container: "mi-superpoop",
                    },
                });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("CLIENTES ESPECIALES", JSON.stringify(error), "error");
            });
    };

    const GetFile = ({ target }) => {
        const file = target.files[0].name.split(".");
        if (file.length > 2) {
            Swal.fire("Clientes", "Archivo invalido", "error");
            return;
        }

        if (
            file[1] !== "jpg" &&
            file[1] !== "jepg" &&
            file[1] !== "pdf" &&
            file[1] !== "PDF"
        ) {
            Swal.fire("Clientes", "Archivo con formato no valido", "error");
            target.value = "";
            return;
        }
        var fReader = new FileReader();
        fReader.readAsDataURL(target.files[0]);
        fReader.onloadend = function (event) {
            setEvidencia({
                ...evidencia,
                documento: event.target.result,
                extension: file[1],
            });
        };
    };

    // console.log(cliente)
    return (
        <>
            <Modal open={open} onClose={onClose}>
                <div className="agregar-cliente-especial-modal-formulario">
                    <div className="agregar-cliente-especial-modal-plantilla">
                        <div className="plantilla-screen-filtro-container" id="mdlFiltros-modal">
                            <PlantillaScreen
                                titulo={"SUBIR DOCUMENTO DE CLIENTES ESPECIALES"}
                                className_main={1}
                                className={"plantilla-screen-filtro-container-modal"}
                            >
                                <div className="cerrar-modal-button" onClick={onClose}>X</div>
                                <div className={`agregar-cliente-especial-modal-agregar-convenio`}>
                                    <div className="agregar-cliente-especial-modal-agregar-convenio-container scroll-4">
                                        <h3 className="titulo-seccion">Agregar Listado de Clientes Especiales</h3>
                                        <TextField
                                            id="clientes-documento"
                                            type="file"
                                            onChange={GetFile}
                                            sx={{ mb: 2, mt: 2 }}
                                        />
                                    </div>
                                    <div className="agregar-cliente-especial-modal-buttons">
                                        <button
                                            className="agregar-cliente-especial-modal-button-guardar"
                                            onClick={() => AgregarCliente()}
                                        >
                                            Guardar
                                        </button>
                                    </div>
                                </div>
                            </PlantillaScreen>
                        </div>

                    </div>
                </div>
            </Modal >
        </>
    );
};

export default SubirListadoModal;